'use client';

import clsx from 'clsx';
import { FC } from 'react';
import Icon from '~/components/icon';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import emailHref from '~/utils/email-href';

import { useCallModal } from '../call-modal-provider';
import CitySelectDesktop from '../city/desktop';
import styles from './styles.module.css';

interface Props {
  email: string | null;
  canOrderCall: boolean;
}

const TopBar: FC<Props> = ({ email, canOrderCall }) => {
  const { captureGoal } = useMetrika();
  const { openModal } = useCallModal();

  const onEmailClick = () => {
    captureGoal(YMGoal.EMAIL_CLICK);
  };

  const onCallClick = () => {
    openModal();
  };

  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        <CitySelectDesktop />

        <div className={styles.actions}>
          {email && (
            <a
              onClick={onEmailClick}
              href={emailHref(email)}
              target="_blank"
              rel="noreferrer"
              className={clsx(styles.action, styles.emailAction)}
            >
              <span>{email}</span>
            </a>
          )}

          {canOrderCall && (
            <button type="button" onClick={onCallClick} className={styles.action}>
              <Icon name="phone-header" className={styles.phoneIcon} />
              <span>Заказать звонок</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
